module.exports = __webpack_public_path__ + "media/images/players/GARCIA_SERGIO-a6a9894c9687d48ff74a0265dcca60b6.png";